import DocumentType from '../../services/documentType'
import * as types from '../mutationTypes'

let state = {
  error: null,
  id: null,
  documentType: null,
  documentTypes: [],
  archived: [],
  headers: [
    { text: 'Id', value: 'id' },
    { text: 'Name', value: 'name' },
    { text: 'Description', value: 'description' },
    { text: 'Actions', value: 'action', sortable: false }
  ]
}

const getters = {
  selectList (state) {
    return state.documentTypes.map(documentType => {
      return { text: documentType.name, value: documentType.id }
    })
  },
  slugs (state) {
    let allTypes = state.documentTypes.concat(state.archived)

    return allTypes.map((type) => {
      return { text: type.slug, value: type.id, archived: type.archived }
    })
  },
  id (state) {
    return state.id
  },
  types (state) {
    return state.documentTypes
  },
  headers () {
    return state.headers
  },
  error (state) {
    return state.error
  },
  archivedList (state) {
    return state.archived
  },
  documentType (state) {
    return state.documentType
  }
}

const actions = {
  async loadAllDocumentTypes ({ commit, dispatch }) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await DocumentType.get(1000, 0, false) // TODO: next iteration add dynamic fetching, for now defualt 1000/0
      if (res) {
        commit(types.REQUEST_GET_DOCUMENTTYPE_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_GET_DOCUMENTTYPE_ERROR, 'Error getting document types')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async loadArchives ({ commit }) {
    try {
      let res = await DocumentType.get(1000, 0, true) // TODO: next iteration add dynamic fetching, for now defualt 100/0
      if (res) {
        commit(types.REQUEST_GET_DOCUMENTTYPE_ARCHIVED_SUCCESS, res.data)
      }
    } catch (err) { // Hiding 404 not found on archived. Don't need to actually show that as an error on doctypes page
      let message = 'Error getting archived document types'
      if (err.message === 'Request failed with status code 404') {
        message = null
      }
      commit(types.REQUEST_GET_DOCUMENTTYPE_ARCHIVED_ERROR, message)
    }
  },
  async createDocumentType ({ commit, dispatch }, type) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await DocumentType.create(type)
      if (res) {
        commit(types.REQUEST_CREATE_DOCUMENTTYPE_SUCCESS, res.data)
        dispatch('loadAllDocumentTypes')
      }
    } catch (err) {
      commit(types.REQUEST_CREATE_DOCUMENTTYPE_ERROR, 'Error creating document type')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async updateDocumentType ({ commit, dispatch }, type) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await DocumentType.update(type)
      if (res) {
        commit(types.REQUEST_UPDATE_DOCUMENTTYPE_SUCCESS, res.data)
        dispatch('loadAllDocumentTypes')
      }
    } catch (err) {
      commit(types.REQUEST_UPDATE_DOCUMENTTYPE_ERROR, 'Error updating document type')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async archiveDocumentType ({ commit, dispatch }, id) {
    try {
      let res = await DocumentType.archive(id)
      if (res) {
        commit(types.REQUEST_ARCHIVE_DOCUMENTTYPE_SUCCESS, res.data)
        dispatch('loadAllDocumentTypes')
        dispatch('loadArchives')
      }
    } catch (err) {
      commit(types.REQUEST_ARCHIVE_DOCUMENTTYPE_ERROR, 'Error archiving document type')
    }
  },
  async restoreDocumentType ({ commit, dispatch }, id) {
    try {
      let res = await DocumentType.restore(id)
      if (res) {
        commit(types.REQUEST_RESTORE_DOCUMENTTYPE_SUCCESS, res.data)
        dispatch('loadAllDocumentTypes')
        dispatch('loadArchives')
      }
    } catch (err) {
      commit(types.REQUEST_RESTORE_DOCUMENTTYPE_ERROR, 'Error restoring document type')
    }
  },
  clearErrors ({ commit }) {
    commit(types.CLEAR_DOCUMENTTYPE_ERROR)
  }
}

const mutations = {
  [types.REQUEST_GET_DOCUMENTTYPE_SUCCESS] (state, data) {
    state.documentTypes = data
    state.error = null
  },
  [types.REQUEST_GET_DOCUMENTTYPE_ERROR] (state, message) {
    state.error = message
    state.documentTypes = []
  },
  [types.REQUEST_GET_DOCUMENTTYPE_ARCHIVED_SUCCESS] (state, data) {
    state.archived = data
    state.error = null
  },
  [types.REQUEST_GET_DOCUMENTTYPE_ARCHIVED_ERROR] (state, message) {
    state.archived = []
    state.error = message
  },
  [types.REQUEST_CREATE_DOCUMENTTYPE_SUCCESS] (state, data) {
    state.documentType = data
    state.id = data.id
    state.error = null
  },
  [types.REQUEST_CREATE_DOCUMENTTYPE_ERROR] (state, message) {
    state.documentType = null
    state.id = null
    state.error = message
  },
  [types.REQUEST_UPDATE_DOCUMENTTYPE_SUCCESS] (state, data) {
    state.documentType = data
    state.id = data.id
    state.error = null
  },
  [types.REQUEST_UPDATE_DOCUMENTTYPE_ERROR] (state, message) {
    state.documentType = null
    state.id = null
    state.error = message
  },
  [types.REQUEST_ARCHIVE_DOCUMENTTYPE_SUCCESS] (state, data) {
    state.documentType = data
    state.error = null
  },
  [types.REQUEST_ARCHIVE_DOCUMENTTYPE_ERROR] (state, message) {
    state.documentType = null
    state.error = message
  },
  [types.REQUEST_RESTORE_DOCUMENTTYPE_SUCCESS] (state, data) {
    state.documentType = data
    state.error = null
  },
  [types.REQUEST_RESTORE_DOCUMENTTYPE_ERROR] (state, message) {
    state.documentType = null
    state.error = message
  },
  [types.CLEAR_DOCUMENTTYPE_ERROR] (state) {
    state.error = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
